import { z } from 'zod';

export const OrderDeletedEventPayloadSchema = z.object({
    id: z.string().uuid(),
});

export type OrderDeletedEventPayload = z.infer<typeof OrderDeletedEventPayloadSchema>;
